import { getPost } from '@/utils/request.js'
export const mySendPost = (url, param) => getPost(url, param, false, false, false, '/df-gw');

const checkApiSuccess = (res) => res && res.data && res.data.code && res.data.code.endsWith('000000');
const rejectApiError = (res) => {
  if (!checkApiSuccess(res)) {
    return Promise.reject(res);
  }
  return res;
};

/**
 * 将新的省市区街道接口数据封装成旧的接口数据
 */
const transformAreaResponse = (res) => {
  const records = res && res.data && res.data.data && res.data.data.records || [];
  return {
    ...res,
    data: {
      ...res.data,
      body: records.map(({ id, name, enName }) => ({
        id,
        nameCh: name,
        nameEn: enName || '',
        name,
        enName
      }))
    }
  };
};


/**
 * 省
 */
export const getAllProvince = (data) => {
  return mySendPost('/location/area/getallprovince', { ...data }).then(rejectApiError).then(transformAreaResponse);
};
/**
 * 市
 */
export const getAllCityByProvince = (data) => {
  return mySendPost('/location/area/getallcitybyprovince', { ...data }).then(rejectApiError).then(transformAreaResponse);
};
/**
 * 区
 */
export const getAllRegionByCity = (data) => {
  return mySendPost('/location/area/getallregionbycity', { ...data }).then(rejectApiError).then(transformAreaResponse);
};
/**
 * 街道
 */
export const getAllStreetByRegion = (data) => {
  return mySendPost('/location/area/getallstreetbyregion', { ...data }).then(rejectApiError).then(transformAreaResponse);
};

const tranformDefaultAddressResponse = (res) => {
  const newData = res && res.data && res.data.data;
  return {
    ...res,
    data: {
      ...res.data,
      body: {
        district: {
          id: newData.province.provinceId, name: newData.province.provinceName, enName: newData.province.provinceEnName,
        }, city: {
          id: newData.city.id, name: newData.city.cityName, enName: newData.city.cityEnName,
        }, region: {
          id: newData.region.regionId, name: newData.region.regionName, enName: newData.region.regionEnName,
        }, streets: newData.streets.map(street => ({
          id: street.streetId, name: street.streetName, enName: street.streetEnName,
        })),
      },
    }
  };
};

/**
 * 获取默认城市
 */
export const reqDefaultAddress = (data) => {
  return mySendPost('/location/area/getdefaultaddress', { ...data }).then(tranformDefaultAddressResponse);
};

/**
 * 格式化城市数据
 * @param res 
 * @returns 
 */
export function transformCities(res) {
  const { data } = res && res.data;

  if (!data) {
    console.error('数据格式错误或缺少必要字段');
    return res; // 保持原始数据结构不变
  }

  // 抽取一个通用的映射函数
  const mapCityList = (list) =>
    list.map((item) => ({
      ...item,
      cityId: item.id,
      name: item.cityName,
      pinyin: item.pinyin,
      first: item.aleph,
    }));

  return {
    ...res, // 保持原有的其他字段
    data: {
      ...data,
      cityList: mapCityList(data.cityList) || data.cityList,
      historyCities: mapCityList(data.historyCities) || data.historyCities,
      hotCities: mapCityList(data.hotCities) || data.hotCities,
    }
  };
}

/**
 * 格式化-经纬度转地址的数据
 * @param {*} res 
 */
export function transformLocation(res) {
  const data = res && res.Data && res.Data.data;

  if (!data) {
    console.error('数据格式错误或缺少必要字段');
    return res; // 保持原始数据结构不变
  }

  // 抽取一个通用的映射函数
  const objectCity = (obj) => {
    return {
      ...obj,
      nameCh: obj && obj.name,
      nameEn: obj && obj.enName,
    }
  }

  return {
    ...res, // 保持原有的其他字段
    data: {
      ...data,
      city: objectCity(data.city) || data.city,
      street: objectCity(data.street) || data.street,
      region: objectCity(data.region) || data.region,
      district: objectCity(data.province) || data.province,
    }
  };
}